import { render, staticRenderFns } from "./DeploymentCard.vue?vue&type=template&id=67eea056&"
import script from "./DeploymentCard.vue?vue&type=script&lang=js&"
export * from "./DeploymentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports